import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class InvoiceChargeTypeApiProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	async IsChargeTypeAlreadyUsed(chargeTypeId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/IsChargeTypeAlreadyUsed`, { chargeTypeId });
	}
}

export const apiProvider = new InvoiceChargeTypeApiProvider();
